import { kebabCaseToWords, createEmailFromName, getStore, getConfig } from "@strangeanimals/common-vue-components/src/helpers/helpers";
import { DateTime } from 'luxon';
import { RefundStatuses } from './constants';

export function getPaymentMethodName(paymentMethod){
    if (paymentMethod === 'eft') {
        return 'Bank Transfer';
    } else if (paymentMethod === 'credit-card') {
        return 'Credit Card or Debit Card';
    }
    else {
        return kebabCaseToWords(paymentMethod);
    }
}

export function getPaginationDetails(pagination) {
    return {
        currentPage: pagination ? pagination.current_page : null,
        lastPage: pagination ? pagination.last_page : null,
        total: pagination ? pagination.total : null,
        count: pagination ? pagination.to - pagination.from + 1 : null,
        perPage: pagination ? pagination.per_page : null,
        firstItem: pagination ? pagination.from : null,
        lastItem: pagination ? pagination.to : null
    };
}

export function createDummyCustomerEmail(firstName, surname) {
    return createEmailFromName(firstName, surname, "@customer.simonds.com.au");
}

export function utcTimestampToLocalTime(timestamp, timezone) {
    return DateTime.fromSeconds(timestamp, {zone: timezone}).setZone('local');
}

export function utcTimestampToLocalRelativeDate(timestamp, timezone) {
    return utcTimestampToLocalTime(timestamp, timezone).toRelative();
}

export function utcTimestampToLocalPrettyDate(timestamp, timezone) {
    let localTime = utcTimestampToLocalTime(timestamp, timezone);
    let diff = localTime.diffNow(['weeks', 'days']).toObject();
    let result = '';
    if (diff.weeks <= -1) {
        result = localTime.toFormat('dd/LL/yyyy') + ' at ' + localTime.toFormat('hh:mm a');
    } else if (diff.days <= -1) {
        result = localTime.toRelative() + ' at ' + localTime.toFormat('hh:mm a');
    } else {
        result = localTime.toRelative();
    }
    return result;
}

export function deriveReportStartDate(localDateTime, timezone)
{
    // Get 5:30 PM of previous day
    return localDateTime.minus({days: 1}).set({hour: 17, minute: 30, second: 0}).setZone(timezone).toFormat('yyyy-LL-dd HH:mm:ss');
}

export function deriveReportEndDate(localDateTime, timezone)
{
    // Get 5:30 PM of current day
    return localDateTime.set({hour: 17, minute: 30, second: 0}).setZone(timezone).toFormat('yyyy-LL-dd HH:mm:ss');
}

export function checkIfAuthorized(next) {
    checkTokenExpiration();
    const store = getStore();
    if(store.getters.isUserLoggedIn) {
        next();
    } else {
        next('/sign-in');
    }
}

function checkTokenExpiration() {
    const config = getConfig();
    const store = getStore();

    let tokenCreatedTimestamp = store.getters.tokenCreatedTimestamp;
    let tokenExpirationHours = config.tokenExpirationHours;
    let now = DateTime.utc();

    if (!tokenCreatedTimestamp || (DateTime.fromISO(tokenCreatedTimestamp, {zone: 'UTC'}).plus({hours: tokenExpirationHours}) < now)) {
        store.commit('updateUser', null);
    }
}

export function isUserApproverOfRefund(refundRequest) {
    const store = getStore();

    return store.getters.user.id === refundRequest.to_be_approved_by_id;
}

export function showApproveOrRejectButtons(refundRequest) {
    const store = getStore();

    return refundRequest
        && refundRequest.status === RefundStatuses.SUBMITTED
        && store.getters.canUserApproveRefunds;
}

export function showCancelButton(refundRequest) {
    const store = getStore();

    if (!store.getters.user) {
        return false;
    }

    let canUserCancelRefunds = (refundRequest && refundRequest.refundable_details && (refundRequest.refundable_details.manager_id === store.getters.user.id))
        || store.getters.isUserRefundsAdmin
        || store.getters.isUserNationalManager;

    return refundRequest && (
        ([RefundStatuses.SUBMITTED].includes(refundRequest.status) && ((store.getters.user.id === refundRequest.requested_by_id) || canUserCancelRefunds))
        || ([RefundStatuses.APPROVED, RefundStatuses.PENDING].includes(refundRequest.status) && !isPaidByCard(refundRequest.payment_method) && canUserCancelRefunds)
    );
}

export function showVerifyButton(refundRequest) {
    const store = getStore();

    return refundRequest
        && refundRequest.status === RefundStatuses.PENDING
        && (store.getters.canUserVerifyRefunds);
}

export function showDownloadButton(refundRequest, isVerifySection) {
    const store = getStore();
    const validStatuses = [
        RefundStatuses.APPROVED,
        RefundStatuses.PENDING,
        RefundStatuses.VERIFIED,
        RefundStatuses.FINALISED
    ];

    return refundRequest
        && isVerifySection
        && validStatuses.includes(refundRequest.status)
        && (store.getters.canUserVerifyRefunds || store.getters.isUserRefundsAdmin);
}

export function filterNullThenCombine(list, combiner) {
    let result = list.filter((item) => { return item !== null});

    return result.join(combiner);
}

export function getSalesforceAcctName(title) {
    let salesforceAccount = "Simonds";
    if (title && title.toLowerCase().includes('startpoint')) {
        salesforceAccount = 'Start Point';
    }

    return salesforceAccount;
}

export function convertUtcDateToLocal(date, format = 'yyyy-LL-dd hh:mm:ss a (z)') {
    return date ?
        DateTime.fromSQL(date, {zone: 'UTC'})
            .toLocal()
            .toFormat(format)
        : null;
}

export function isPaidByCard(paymentMethod) {
    return paymentMethod.includes('Card');
}